module.exports = __webpack_public_path__ + "media/images/admin/icons/minus-595a628f1d89b51f5ee67012ae076ac8.svg";